import PropTypes from "prop-types";
import React from "react";

function SearchInput(_ref) {
  var getAutocomplete = _ref.getAutocomplete,
      getButtonProps = _ref.getButtonProps,
      getInputProps = _ref.getInputProps;
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "sui-search-box__wrapper"
  }, React.createElement("input", getInputProps()), getAutocomplete()), React.createElement("input", getButtonProps()));
}

SearchInput.propTypes = {
  getAutocomplete: PropTypes.func.isRequired,
  getButtonProps: PropTypes.func.isRequired,
  getInputProps: PropTypes.func.isRequired
};
export default SearchInput;